/***
 * 创建人：zll
 * 时间：2021-10-28
 * 描述：对护照进行验证
 * 更新记录: 
 */
import { Directive} from "@angular/core"
import { Validator, AbstractControl, NG_VALIDATORS} from "@angular/forms"

@Directive({
  selector:"[validatorPassportcard]",
  providers:[{
    provide:NG_VALIDATORS,
    useExisting:ValidatorPassportcardDirective,
    multi:true
  }]
})
export class ValidatorPassportcardDirective implements Validator{
  constructor(){

  }
  validate(control:AbstractControl):{[property:string]:string}{
      // 护照
      // 规则： 14/15开头 + 7位数字, G + 8位数字, P + 7位数字, S/D + 7或8位数字,等
      // 样本： 141234567, G12345678, P1234567
      let regPP=/^([a-zA-z]|[0-9]){5,17}$/;
      //输入框的值
      let idcard=control.value;

      //为空时不验证
      if(!idcard || idcard==""){
        return null
      }
      if(regPP.test(idcard)){
         return null
      }else{
         return {validatorPassportcard:"护照格式不匹配"}
      }
  }
}